import { api, apiComm } from './api-core';

export const WorkshopAdminApi = {
    getListProposal: () => {
        const url = `${process.env.API_WORKSHOP_ADMIN_GET_LIST_PROPOSAL}`;
        return api.get(url as string).then((res) => {
            return res.data?.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    },
    
    approveProposal: (proposalId: number) => {
        const url = `${process.env.API_WORKSHOP_ADMIN_APPROVE_PROPOSAL}`;
        return api.post(url as string, { proposal_id: proposalId }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            return res.data;
        }).catch((err) => {
            console.error('Error approving proposal:', err);
            throw err;
        });
    },
    
    rejectProposal: (proposalId: number, adminNotes: string) => {
        const url = `${process.env.API_WORKSHOP_ADMIN_REJECT_PROPOSAL}`;
        return api.post(url as string, { 
            proposal_id: proposalId,
            admin_notes: adminNotes 
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            return res.data;
        }).catch((err) => {
            console.error('Error rejecting proposal:', err);
            throw err;
        });
    },
    
    requestRevisionProposal: (proposalId: number, adminNotes: string) => {
        const url = `${process.env.API_WORKSHOP_ADMIN_REQUEST_REVISION_PROPOSAL}`;
        return api.post(url as string, 
            { 
                proposal_id: proposalId,
                admin_notes: adminNotes,
            }
            , {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            return res.data;
        }).catch((err) => {
            console.error('Error requesting revision:', err);
            throw err;
        });
    },
    getRegisterByWorkshop: (workshopId: number) => {
        const url = `${process.env.API_WORKSHOP_ADMIN_GET_REGISTER_BY_WORKSHOP}`;
        return api.get(url as string, {
            params: {
                workshop_id: workshopId
            }
        }).then((res) => {
            return res.data;
        }).catch((err) => {
            console.error('Error getting register by workshop:', err);
            throw err;
        });
    },
    sendBulkEmail: (workshopId: number, subject: string, content: string) => {
        const url = `${process.env.API_WORKSHOP_ADMIN_SEND_BULK_EMAIL}`;
        return api.post(url as string, {
            workshop_id: workshopId,
            subject: subject,
            content: content
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            return res.data;
        }).catch((err) => {
            console.error('Error sending bulk email:', err);
            throw err;
        });
    },
    cancelWorkshop: (workshopId: string, reason: string) => {
        const url = `${process.env.API_WORKSHOP_ADMIN_CANCEL_WORKSHOP}`;
        return api.post(url as string, {
            workshop_id: workshopId,
            reason: reason
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            return res.data;
        }).catch((err) => {
            console.error('Error canceling workshop:', err);
            throw err;
        });
    },
    getListUser: () => {
        const url = `${process.env.API_WORKSHOP_ADMIN_GET_LIST_USER}`;
        return api.get(url as string).then((res) => {
            return res.data;
        }).catch((err) => {
            console.error('Error getting list user:', err);
            throw err;
        });
    },
    getListEmailTrigger: () => {
        const url = `${process.env.API_WORKSHOP_ADMIN_GET_LIST_EMAIL_TRIGGER}`;
        return api.get(url as string).then((res) => {
            return res.data?.data || [];
        }).catch((err) => {
            console.error('Error getting list email trigger:', err);
            throw err;
        });
    },
    getListEmailTemplate: (triggerId: number) => {
        const url = `${process.env.API_WORKSHOP_ADMIN_GET_LIST_TEAMPLTE_BY_TRIGGER}`;
        return api.get(url as string, {
            params: {
                trigger_id: triggerId
            }
        }).then((res) => {
            return res.data?.data || [];
        }).catch((err) => {
            console.error('Error getting list email template:', err);
            throw err;
        });
    },
    addEmailTemplate: (triggerId: number, name: string, subject: string, body: string, workshop_ids: (number|string)[]) => {
        const url = `${process.env.API_WORKSHOP_ADMIN_CREATE_EMAIL_TEMPLATE}`;
        return api.post(url as string, {
            trigger_id: triggerId,
            name: name,
            subject: subject,
            body: body,
            workshop_ids: workshop_ids
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            return res.data;
        }).catch((err) => {
            console.error('Error adding email template:', err);
            throw err;
        });
    },
    updateEmailTemplate: (id: number, name: string, subject: string, body: string, workshop_ids: (number|string)[]) => {
        const url = `${process.env.API_WORKSHOP_ADMIN_UPDATE_EMAIL_TEMPLATE}`;
        return api.post(url as string, {
            id: id,
            name: name,
            subject: subject,
            body: body,
            workshop_ids: workshop_ids
        }, {
            headers: {  
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            return res.data;
        }).catch((err) => {
            console.error('Error updating email template:', err);
            throw err;
        });
    },
    deleteEmailTemplate: (id: number) => {
        const url = `${process.env.API_WORKSHOP_ADMIN_DELETE_EMAIL_TEMPLATE}`;
        return api.post(url as string, {
            id: id
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            return res.data;
        }).catch((err) => {
            console.error('Error deleting email template:', err);
            throw err;
        });
    },
    setDefaultEmailTemplate: (id: number) => {
        const url = `${process.env.API_WORKSHOP_ADMIN_SET_DEFAULT_EMAIL_TEMPLATE}`;
        return api.post(url as string, {
            id: id
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            return res.data;
        }).catch((err) => {
            console.error('Error setting default email template:', err);
            throw err;
        });
    },

    getWorkshopAnalyticsById: (id?: any) => {
      const params = new URLSearchParams();
      if (id) params.append("id", id);

      const url = `${process.env.API_WORKSHOP_ADMIN_GET_WORKSHOP_ANALYTICS_BY_ID}?${params.toString()}`;
      return api
        .get(url as string)
        .then((res) => {
          return res.data || [];
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    adminGetWorkshopById: (id?: any, username?: any, userTimeZone?: any) => {
      const params = new URLSearchParams();
      if (id) params.append("id", id);
      if (username) params.append("username", username);
      if (userTimeZone) params.append("userTimeZone", userTimeZone);
      const url = `${process.env.API_WORKSHOP_ADMIN_GET_WORKSHOP_BY_ID}?${params.toString()}`;
      return api
        .get(url as string)
        .then((res) => {
          return res.data || [];
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },

    createWorkshopCategory: (data: {
        name?: string
    }) => {
      const formData = new FormData();
      // Duyệt qua tất cả các trường trong data và thêm vào formData
      Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          if (Array.isArray(value)) {
            value.forEach((item, index) => {
              if (typeof item === "object") {
                // Duyệt từng field của object trong mảng
                Object.entries(item).forEach(([subKey, subValue]) => {
                  if (subValue !== undefined && subValue !== null) {
                    formData.append(
                      `${key}[${index}][${subKey}]`,
                      subValue.toString()
                    );
                  }
                });
              } else {
                formData.append(`${key}[${index}]`, item.toString());
              }
            });
          } else if (typeof value === "object") {
            // Nếu là object, stringify toàn bộ (nếu cần)
            formData.append(key, JSON.stringify(value));
          } else {
            // Nếu là giá trị đơn giản, thêm vào bình thường
            formData.append(key, value.toString());
          }
        }
      });

      const url = process.env.API_WORKSHOP_ADMIN_CREATE_CATEGORY;

      return api
        .post(url as string, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => res.data)
        .catch((err) => {
          console.error("Error:", err);
          throw err; // Ném lỗi để xử lý ở nơi gọi hàm
        });
    },

    deleteWorkshopCategory: (data: {
        id?: any
    }) => {
      const formData = new FormData();
      // Duyệt qua tất cả các trường trong data và thêm vào formData
      Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          if (Array.isArray(value)) {
            value.forEach((item, index) => {
              if (typeof item === "object") {
                // Duyệt từng field của object trong mảng
                Object.entries(item).forEach(([subKey, subValue]) => {
                  if (subValue !== undefined && subValue !== null) {
                    formData.append(
                      `${key}[${index}][${subKey}]`,
                      subValue.toString()
                    );
                  }
                });
              } else {
                formData.append(`${key}[${index}]`, item.toString());
              }
            });
          } else if (typeof value === "object") {
            // Nếu là object, stringify toàn bộ (nếu cần)
            formData.append(key, JSON.stringify(value));
          } else {
            // Nếu là giá trị đơn giản, thêm vào bình thường
            formData.append(key, value.toString());
          }
        }
      });

      const url = process.env.API_WORKSHOP_ADMIN_DELETE_CATEGORY;

      return api
        .post(url as string, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => res.data)
        .catch((err) => {
          console.error("Error:", err);
          throw err; // Ném lỗi để xử lý ở nơi gọi hàm
        });
    },

    updateWorkshopCategory: (data: {
        id?: any,
        name?: any
    }) => {
      const formData = new FormData();
      // Duyệt qua tất cả các trường trong data và thêm vào formData
      Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          if (Array.isArray(value)) {
            value.forEach((item, index) => {
              if (typeof item === "object") {
                // Duyệt từng field của object trong mảng
                Object.entries(item).forEach(([subKey, subValue]) => {
                  if (subValue !== undefined && subValue !== null) {
                    formData.append(
                      `${key}[${index}][${subKey}]`,
                      subValue.toString()
                    );
                  }
                });
              } else {
                formData.append(`${key}[${index}]`, item.toString());
              }
            });
          } else if (typeof value === "object") {
            // Nếu là object, stringify toàn bộ (nếu cần)
            formData.append(key, JSON.stringify(value));
          } else {
            // Nếu là giá trị đơn giản, thêm vào bình thường
            formData.append(key, value.toString());
          }
        }
      });

      const url = process.env.API_WORKSHOP_ADMIN_UPDATE_CATEGORY;

      return api
        .post(url as string, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => res.data)
        .catch((err) => {
          console.error("Error:", err);
          throw err; // Ném lỗi để xử lý ở nơi gọi hàm
        });
    },


    getSummary: (
      userTimeZone?: any
    ) => {
      const params = new URLSearchParams();
      if (userTimeZone) params.append("userTimeZone", userTimeZone);
  
      const url = `${process.env.API_WORKSHOP_ADMIN_GET_SUMMARY}?${params.toString()}`;
      return api
        .get(url as string)
        .then((res) => {
          return res.data || [];
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    reconsiderProposal: (proposalId: number) => {
        const url = `${process.env.API_WORKSHOP_ADMIN_RECONSIDER_PROPOSAL}`;
        return api.post(url as string, {
            proposal_id: proposalId
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            return res.data;
        }).catch((err) => {
            console.error('Error reconsideing proposal:', err);
            throw err;
        });
    }
}